import { isExperimentOpen as skylabIsExperimentOpen } from '@wix/skylab'

// FOR TESTING ONLY: add your experiment here to force it open while developing.
// This list must stay empty on master — do NOT merge your additions.
export const FORCE_OPEN_EXPERIMENTS: Array<string> = []

export const isExperimentOpen = (experimentsObj: Record<string, any>, experimentName: string) =>
	FORCE_OPEN_EXPERIMENTS.includes(experimentName) || skylabIsExperimentOpen(experimentsObj, experimentName)

/** Narrows an experiments bag to only its open experiments, each normalised to `true`. */
export const fixExperimentsValues = (experiments?: Record<string, any>): Record<string, true> => {
	if (!experiments) {
		return {}
	}
	return Object.keys(experiments).reduce<Record<string, true>>((acc, key) => {
		if (isExperimentOpen(experiments, key)) {
			acc[key] = true
		}
		return acc
	}, {})
}

const BLOCKED_KEYS = new Set(['__proto__', 'constructor', 'prototype'])

const parseExperimentsQueryString = (queryString: string, defaultValue: string): Record<string, string> =>
	queryString
		.split(/[;,]/)
		.filter((x) => x)
		.reduce((acc, x) => {
			const [rawName, value = defaultValue] = x.split(':')
			const name = rawName.trim()
			if (!name || BLOCKED_KEYS.has(name)) {
				return acc
			}
			return { ...acc, [name]: value }
		}, {})

/** Reads `?experiments=` / `?experimentsOff=` overrides off an absolute url. */
export const getExperimentsFromUrl = (absoluteUrl: string): Record<string, string> => {
	try {
		const parsedUrl = new URL(absoluteUrl)
		const experiments = parsedUrl.searchParams.get('experiments') || ''
		const experimentsOff =
			parsedUrl.searchParams.get('experimentsOff') || parsedUrl.searchParams.get('experimentsoff') || ''
		return {
			...parseExperimentsQueryString(experiments, 'new'),
			...parseExperimentsQueryString(experimentsOff, 'old'),
		}
	} catch {
		return {}
	}
}
